import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const LocationIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path d="M11.9352 3C7.98332 3 4.75 6.23332 4.75 10.1852C4.75 15.0351 11.037 20.5138 11.3065 20.7833C11.4861 20.8731 11.7555 20.9629 11.9352 20.9629C12.1148 20.9629 12.3842 20.8731 12.5639 20.7833C12.8333 20.5138 19.1203 15.0351 19.1203 10.1852C19.1203 6.23332 15.887 3 11.9352 3ZM11.9352 18.8972C10.0491 17.1009 6.54629 13.2388 6.54629 10.1852C6.54629 7.22128 8.97128 4.79629 11.9352 4.79629C14.899 4.79629 17.324 7.22128 17.324 10.1852C17.324 13.149 13.8213 17.1009 11.9352 18.8972ZM11.9352 6.59258C9.95924 6.59258 8.34258 8.20924 8.34258 10.1852C8.34258 12.1611 9.95924 13.7777 11.9352 13.7777C13.9111 13.7777 15.5277 12.1611 15.5277 10.1852C15.5277 8.20924 13.9111 6.59258 11.9352 6.59258ZM11.9352 11.9814C10.9472 11.9814 10.1389 11.1731 10.1389 10.1852C10.1389 9.1972 10.9472 8.38887 11.9352 8.38887C12.9231 8.38887 13.7314 9.1972 13.7314 10.1852C13.7314 11.1731 12.9231 11.9814 11.9352 11.9814Z" fill="currentColor" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props || $[2] !== ref) {
    t1 = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props} ref={ref}>{t0}</svg>;
    $[1] = props;
    $[2] = ref;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  return t1;
});
export default LocationIcon;